import { faEnvelope, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { components } from '@/api/qraft/schema';
import { Tooltip } from '@/common/Tooltip';

type ProfileType = components['schemas']['ProfileType'];

export function ModeIconCell({ mode }: { mode: ProfileType }) {
  const { t } = useTranslation();
  const modeLabel =
    mode === 'WEB_STUDENT'
      ? t('lessons.web-student')
      : mode === 'POSTAL_STUDENT'
        ? t('forum.postal-student')
        : t('lessons.liteapp-student');
  return (
    <Tooltip text={modeLabel} position="bottom">
      <IconCell>
        <FontAwesomeIcon
          icon={mode === 'POSTAL_STUDENT' ? faEnvelope : faGlobe}
          style={{ color: 'var(--grey-700)', fontSize: '22px' }}
        />
      </IconCell>
    </Tooltip>
  );
}

const IconCell = styled.div`
  align-items: center;
  display: flex;
`;
